var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongBangzhufankui(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.643 8a6.63 6.63 0 01-.422 2.335c-.07.189-.208.477-.307.678a.613.613 0 00-.03.47l.648 1.887a.2.2 0 01-.226.261l-1.928-.361a.631.631 0 00-.486.114A6.614 6.614 0 018 14.644 6.643 6.643 0 1114.644 8z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.955v-.326c0-.441.378-.783.77-.985a1.688 1.688 0 10-2.458-1.502",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.546a.7.7 0 100-1.399.7.7 0 000 1.399z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_bangzhufankui.1baa6b04.svg";
export { SvgTongyongBangzhufankui as ReactComponent };